import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { alertAtom, IAlertAtomProps } from '../atom';

export function useAlertService() {
  const [alertConfig, setAlertConfig] = useAtom(alertAtom);

  function setAlert(config: IAlertAtomProps) {
    setAlertConfig(config);
  }

  const closeAlert = useCallback(() => {
    setAlertConfig(null);
  }, [setAlertConfig]);

  return {
    alertConfig,
    closeAlert,
    setAlert,
  };
}
